import { createSlice } from '@reduxjs/toolkit';

const devicesSlice = createSlice({
    name: 'devices',
    initialState: {
        deviceList: []
    },
    reducers: {
        setDeviceList: (state, action) => {
            state.deviceList = action.payload;
        }
    }
});

export const { setDeviceList } = devicesSlice.actions;

export default devicesSlice.reducer;
